import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Input, FormFeedback } from 'reactstrap'
import { get } from 'lodash'

const SelectInput = (props) => {
  const {
    field: { name, ...field },
    form: { errors, touched },
    placeholder,
    source,
    label,
    ...rest
  } = props
  const error = get(errors, name, null)
  const touch = get(touched, name, false)
  const isInvalid = (touch && error)
  return (
    <FormGroup>
      {label && <label>{label}</label>}
      <Input
        type="select"
        name={name}
        invalid={isInvalid ? true : null}
        placeholder={placeholder}
        {...field}
        {...rest}>
        {placeholder &&
          <option
            value=''>
            {placeholder}
          </option>
        }
        {source.map((item, index) => (
          <option
            key={index}
            value={item.value}>
            {item.label}
          </option>
        ))}
      </Input>
      <FormFeedback>{error}</FormFeedback>
    </FormGroup>
  )
}

SelectInput.propTypes = {
  field: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  source: PropTypes.array.isRequired
}

export default SelectInput
